import { render, staticRenderFns } from "./Stock.vue?vue&type=template&id=41487114&scoped=true"
import script from "./Stock.vue?vue&type=script&lang=ts"
export * from "./Stock.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41487114",
  null
  
)

export default component.exports